export var DEPLOY_DATE = new Date('2026-06-01T11:59:10+0000');
